"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _moment = _interopRequireDefault(require("moment"));

var _reactIntl = require("react-intl");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _core = require("@material-ui/core");

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Flag = _interopRequireDefault(require("../Flag/Flag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  background-size: cover;\n  width: 80px;\n  height: 45px;\n  border-radius: 3px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  margin: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 16px;\n  min-width: 288px;\n  background-color: ", ";\n  color: ", ";\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 216px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledGrid = (0, _styledComponents.default)(_Grid.default)(_templateObject());
var Card = (0, _styledComponents.default)(_core.Paper)(_templateObject2(), function (props) {
  return props.theme.palette.primary.main;
}, function (props) {
  return props.theme.palette.common.white;
}, function (props) {
  return "linear-gradient(to right, ".concat(props.theme.palette.common.black, ", ").concat((0, _polished.transparentize)(0.75, props.theme.palette.common.black), "), url(\"").concat(props.background, "\")");
});

var Flat = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.theme.palette.common.black;
});

var TypographyTitle = (0, _styledComponents.default)(_Typography.default)(_templateObject4(), function (props) {
  return props.theme.typography.fontWeightBold;
});
var TypographyDay = (0, _styledComponents.default)(_Typography.default)(_templateObject5());

var ActivityLogo = _styledComponents.default.div(_templateObject6(), function (props) {
  return "url(\"".concat(props.background, "\") no-repeat center");
});

var ActivityFull = (0, _styledComponents.default)(_Grid.default)(_templateObject7());

var ActivityCard = function ActivityCard(_ref) {
  var event = _ref.event,
      isMultiClubs = _ref.isMultiClubs,
      activityBackground = _ref.activityBackground,
      activityLogo = _ref.activityLogo,
      onSubscribe = _ref.onSubscribe,
      onUnsubscribe = _ref.onUnsubscribe,
      isRegistered = _ref.isRegistered,
      coachAvatar = _ref.coachAvatar,
      noBackground = _ref.noBackground,
      props = _objectWithoutProperties(_ref, ["event", "isMultiClubs", "activityBackground", "activityLogo", "onSubscribe", "onUnsubscribe", "isRegistered", "coachAvatar", "noBackground"]);

  var remaningPlaces = event.attendingLimit - event.bookedAttendees.length || 0;
  var isFull = remaningPlaces === 0;
  var Wrapper = noBackground ? Flat : Card;
  return _react.default.createElement(StyledGrid, Object.assign({
    container: true,
    direction: "column",
    style: {
      position: 'relative'
    },
    background: activityBackground,
    component: Wrapper,
    wrap: "nowrap"
  }, props), _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(_Grid.default, {
    container: true,
    spacing: 8,
    wrap: "nowrap"
  }, _react.default.createElement(_Grid.default, {
    item: true,
    xs: 8
  }, _react.default.createElement(TypographyDay, {
    variant: "body2",
    color: "inherit"
  }, (0, _moment.default)(event.startedAt).format('dddd D MMMM YYYY')), isMultiClubs && _react.default.createElement(_Typography.default, {
    noWrap: true,
    title: (0, _lodash.default)(event, ['club', 'name']),
    variant: "body2",
    color: "inherit"
  }, (0, _lodash.default)(event, ['club', 'name']))), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 4
  }, _react.default.createElement(ActivityLogo, {
    background: activityLogo
  })))), _react.default.createElement(_Grid.default, {
    item: true,
    container: true,
    xs: true,
    direction: "column",
    justify: "center",
    spacing: 8
  }, _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(TypographyTitle, {
    title: (0, _lodash.default)(event, ['activity', 'name']),
    variant: "h2",
    color: "inherit",
    gutterBottom: true
  }, (0, _lodash.default)(event, ['activity', 'name']))), _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(_Grid.default, {
    container: true,
    alignItems: "center",
    spacing: 16,
    wrap: "nowrap"
  }, _react.default.createElement(_Grid.default, {
    item: true,
    xs: 3
  }, _react.default.createElement(_Typography.default, {
    variant: "h3",
    color: "inherit",
    fontWeight: "fontWeightBold"
  }, (0, _moment.default)(event.startedAt).format('HH:mm'))), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 3
  }, _react.default.createElement(_Typography.default, {
    variant: "subtitle1",
    component: "p",
    color: "inherit",
    style: {
      whiteSpace: 'nowrap'
    }
  }, (0, _moment.default)(event.endedAt).diff((0, _moment.default)(event.startedAt), 'minutes'), " min")), _react.default.createElement(_Grid.default, {
    item: true,
    xs: 6
  }, _react.default.createElement(_Typography.default, {
    noWrap: true,
    title: (0, _lodash.default)(event, ['studio', 'name']),
    variant: "body2",
    color: "inherit"
  }, (0, _lodash.default)(event, ['studio', 'name'])))))), _react.default.createElement(_Grid.default, {
    container: true,
    item: true,
    alignItems: "flex-end",
    xs: true
  }, !!event.coach && _react.default.createElement(_Grid.default, {
    item: true,
    xs: 5
  }, _react.default.createElement(_Grid.default, {
    container: true,
    direction: "column"
  }, _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(_Typography.default, {
    variant: "body2",
    color: "inherit",
    fontWeight: "fontWeightSemiBold"
  }, "Votre coach")), _react.default.createElement(_Grid.default, {
    item: true,
    container: true,
    alignItems: "center",
    style: {
      height: '40px'
    }
  }, coachAvatar ? _react.default.createElement(_Avatar.default, {
    src: coachAvatar,
    size: "xs"
  }) : _react.default.createElement(_Typography.default, {
    noWrap: true,
    title: event.coach.alternateName ? event.coach.alternateName : "".concat(event.coach.givenName, " ").concat(event.coach.familyName),
    variant: "body2",
    color: "inherit"
  }, event.coach.alternateName ? event.coach.alternateName : "".concat(event.coach.givenName, " ").concat(event.coach.familyName))))), onSubscribe && onUnsubscribe && _react.default.createElement(_Grid.default, {
    item: true,
    xs: true
  }, _react.default.createElement(_Grid.default, {
    container: true,
    direction: "column",
    alignItems: "flex-end"
  }, isFull ? _react.default.createElement(ActivityFull, {
    item: true,
    xs: false
  }, _react.default.createElement(_Flag.default, {
    color: "warning"
  }, "Complet")) : _react.default.createElement(_Grid.default, {
    item: true
  }, _react.default.createElement(_Typography.default, {
    noWrap: true,
    variant: "caption",
    component: "p",
    gutterBottom: true,
    color: "inherit"
  }, _react.default.createElement(_reactIntl.FormattedPlural, {
    value: remaningPlaces,
    one: "place restante",
    other: "places restantes"
  }, function (formattedPlural) {
    return "".concat(remaningPlaces, " ").concat(formattedPlural);
  }))), _react.default.createElement(_Grid.default, {
    item: true
  }, !isFull && !isRegistered && _react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    style: {
      margin: '0'
    },
    onClick: onSubscribe
  }, "S'inscrire"), isRegistered && _react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    style: {
      margin: '0'
    },
    onClick: onUnsubscribe
  }, "Se d\xE9sinscrire"))))));
};

ActivityCard.defaultProps = {
  activityBackground: '',
  activityLogo: '',
  coachAvatar: '',
  isRegistered: false,
  noBackground: false,
  onSubscribe: null,
  onUnsubscribe: null,
  isMultiClubs: false
};
var _default = ActivityCard;
exports.default = _default;